import { css, html, LitElement } from 'lit';
export class Paragraph extends LitElement {
    render() {
        return html `
            <p>
                <slot></slot>
            </p>
        `;
    }
}
Paragraph.styles = css `
        :host(:focus-visible),
        p:focus-visible {
            outline: 0;
        }

        :host {
            display: block;
        }

        p {
            color: var(--ep-text-color);
            font-size: var(--ep-text-font-size);
            font-family: var(--ep-text-font-family);
            font-weight: var(--ep-text-font-weight);
            margin-block: 0;
            columns: var(--ep-text-columns, 1);
            text-align: var(--ep-paragraph-text-align, left);
        }

        :host([type='error']) p {
            --ep-text-color: var(--ep-color-danger);
        }

        :host([type='warning']) p {
            --ep-text-color: var(--ep-color-warning);
        }

        :host([type='success']) p {
            --ep-text-color: var(--ep-color-success);
        }

        ::slotted(*) {
            display: none;
        }

        ::slotted(span),
        ::slotted(strong),
        ::slotted(i),
        ::slotted(br),
        ::slotted(a),
        ::slotted(q),
        ::slotted(u),
        ::slotted(em),
        ::slotted(small),
        ::slotted(ep-button),
        ::slotted(ep-link),
        ::slotted(ep-icon) {
            display: inline;
        }
    `;
if (!customElements.get('ep-p')) {
    customElements.define('ep-p', Paragraph);
}
//# sourceMappingURL=element.js.map